import React from 'react';
import styled from '@emotion/styled';
import { Grid, Fade, LinearProgress } from '@mui/material';
import OPOrderStep from './OPOrderStep';
import { convertStylesToStyled } from '@/_utils/utils';

const OPOrderStepper = ({ step = 0, isBulkBased = false }) => {
  return (
    <Fade in timeout={600}>
      <Wrapper>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <OPOrderStep heading="Order Details" description="Enter order details and select profiles" active={step === 0} completed={step > 0} />
          </Grid>
          <Grid item>
            <OPOrderStep
              heading={'Content Selection'}
              description={isBulkBased ? 'Bulk Import' : 'Browse and Select Version/Files to Order'}
              active={step === 1}
              completed={step > 1}
            />
          </Grid>
          <Grid item>
            <OPOrderStep
              heading="Review &amp; Submit"
              description="Finalize and complete your order"
              active={step === 2}
              completed={step > 2}
              sx={{ mr: 10 }}
            />
          </Grid>
        </Grid>
        <LinearProgressWrapped variant="determinate" value={isBulkBased && step === 1 ? 50 : (step / 3) * 100} complete={+(step / 3 >= 100)} />
      </Wrapper>
    </Fade>
  );
};

export default OPOrderStepper;

const Wrapper = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(6)};
`;

const LinearProgressWrapped = styled(LinearProgress, { shouldForwardProp: (propName) => !['complete'].includes(propName) })<{ complete: number }>`
  background: ${({ theme }) => theme.palette.action.hover};
  height: 6px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;

  & .MuiLinearProgress-bar {
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    background: linear-gradient(to right, ${({ theme }) => theme.palette.teal.main} 70%, ${({ theme }) => theme.palette.primary.main} 100%);
  }

  ${({ theme }) => convertStylesToStyled(theme.customOverrides?.ProgressBar)};

  ${({ theme, complete }) =>
    complete
      ? `
      & .MuiLinearProgress-bar {
        background: ${theme.palette.teal.main};
      }
      `
      : null};
`;
